/** Möbelkatalog. e = Höhe über Boden (Wandmontage), on = stellt sich automatisch auf Möbel darunter. */
import type { CustomDef } from "@hausplaner/model";

export interface CatalogDef {
  key: string; cat: string; id: string; name: string;
  w: number; d: number; h: number; c: string;
  e?: number; on?: number;
  parts?: CustomDef["parts"];
}
type Entry = Omit<CatalogDef, "key"> & { key?: string };

const ENTRIES: Entry[]=[
 {cat:'Schlafen',id:'bed',name:'Doppelbett',w:1.8,d:2.0,h:.95,c:'#e9e5dc'},
 {cat:'Schlafen',id:'bed',name:'Doppelbett 160',w:1.6,d:2.0,h:.95,c:'#d9d4c9'},
 {cat:'Schlafen',id:'bed',name:'Boxspringbett 200',w:2.0,d:2.1,h:1.15,c:'#8c8f91'},
 {cat:'Schlafen',id:'bed',name:'Bett 140',w:1.4,d:2.0,h:.9,c:'#c9a272',key:'bed140'},
 {cat:'Schlafen',id:'bed',name:'Einzelbett',w:.9,d:2.0,h:.85,c:'#9db4c9',key:'bed90'},
 {cat:'Schlafen',id:'wardrobe',name:'Kleiderschrank',w:2.0,d:.6,h:2.2,c:'#e9e5dc'},
 {cat:'Schlafen',id:'wardrobe',name:'Kleiderschrank 3-türig',w:1.5,d:.6,h:2.2,c:'#d9d4c9'},
 {cat:'Schlafen',id:'wardrobe',name:'Schwebetürenschrank',w:2.5,d:.65,h:2.3,c:'#f5f5f2'},
 {cat:'Schlafen',id:'night',name:'Nachttisch',w:.45,d:.4,h:.5,c:'#c9a272'},
 {cat:'Schlafen',id:'dresser',name:'Kommode',w:1.2,d:.45,h:.85,c:'#e9e5dc'},
 {cat:'Schlafen',id:'dresser',name:'Kommode hoch',w:.8,d:.45,h:1.2,c:'#c9a272'},
 {cat:'Schlafen',id:'bench',name:'Bettbank',w:1.4,d:.4,h:.45,c:'#a3664a'},
 {cat:'Schlafen',id:'mirror',name:'Standspiegel',w:.5,d:.04,h:1.7,c:'#c9a272'},
 {cat:'Kinder',id:'crib',name:'Babybett',w:.78,d:1.44,h:.9,c:'#f5f5f2'},
 {cat:'Kinder',id:'changing',name:'Wickelkommode',w:.9,d:.55,h:1.0,c:'#f5f5f2'},
 {cat:'Kinder',id:'bed',name:'Jugendbett 120',w:1.2,d:2.0,h:.85,c:'#9db4c9'},
 {cat:'Kinder',id:'bunk',name:'Etagenbett',w:.97,d:2.05,h:1.6,c:'#c9a272'},
 {cat:'Kinder',id:'desk',name:'Kinderschreibtisch',w:1.0,d:.6,h:.65,c:'#f5f5f2'},
 {cat:'Kinder',id:'shelf',name:'Kinderregal',w:1.1,d:.4,h:1.1,c:'#f5f5f2'},
 {cat:'Kinder',id:'toybox',name:'Spielzeugkiste',w:.8,d:.45,h:.45,c:'#9db4c9'},
 {cat:'Kinder',id:'rug',name:'Spielteppich',w:1.4,d:2.0,h:.01,c:'#9db4c9'},
 {cat:'Wohnen',id:'sofa',name:'Sofa 3-Sitzer',w:2.2,d:.95,h:.85,c:'#8c8f91'},
 {cat:'Wohnen',id:'sofa',name:'Sofa 2-Sitzer',w:1.6,d:.9,h:.85,c:'#3f6d8c'},
 {cat:'Wohnen',id:'corner',name:'Ecksofa',w:2.8,d:1.8,h:.85,c:'#5f7464'},
 {cat:'Wohnen',id:'corner',name:'Wohnlandschaft',w:3.4,d:2.2,h:.85,c:'#d9d4c9'},
 {cat:'Wohnen',id:'chairArm',name:'Sessel',w:.85,d:.85,h:.85,c:'#a3664a'},
 {cat:'Wohnen',id:'chairArm',name:'Ohrensessel',w:.8,d:.85,h:1.1,c:'#5f7464'},
 {cat:'Wohnen',id:'pouf',name:'Pouf',w:.5,d:.5,h:.42,c:'#c8a6a0'},
 {cat:'Wohnen',id:'beanbag',name:'Sitzsack',w:.9,d:.9,h:.7,c:'#3f4a52'},
 {cat:'Wohnen',id:'coffee',name:'Couchtisch',w:1.1,d:.6,h:.42,c:'#c9a272'},
 {cat:'Wohnen',id:'round',name:'Beistelltisch',w:.5,d:.5,h:.5,c:'#2c2d30'},
 {cat:'Wohnen',id:'tv',name:'TV-Board mit TV',w:1.8,d:.4,h:.5,c:'#2c2d30'},
 {cat:'Wohnen',id:'tvscreen',name:'TV an der Wand 65"',w:1.45,d:.05,h:.84,c:'#2c2d30',e:1.0},
 {cat:'Wohnen',id:'sideboard',name:'Sideboard',w:1.8,d:.45,h:.8,c:'#e9e5dc'},
 {cat:'Wohnen',id:'sideboard',name:'Lowboard',w:2.0,d:.4,h:.5,c:'#3f4a52'},
 {cat:'Wohnen',id:'vitrine',name:'Vitrine',w:.8,d:.4,h:1.9,c:'#e9e5dc'},
 {cat:'Wohnen',id:'shelf',name:'Regal',w:.8,d:.35,h:2.0,c:'#e9e5dc'},
 {cat:'Wohnen',id:'shelf',name:'Bücherwand',w:1.6,d:.35,h:2.2,c:'#c9a272'},
 {cat:'Wohnen',id:'rug',name:'Teppich',w:2.0,d:3.0,h:.01,c:'#c8a6a0'},
 {cat:'Wohnen',id:'rug',name:'Läufer',w:.8,d:2.5,h:.01,c:'#5f7464'},
 {cat:'Wohnen',id:'lamp',name:'Stehleuchte',w:.4,d:.4,h:1.7,c:'#2c2d30'},
 {cat:'Wohnen',id:'plant',name:'Pflanze',w:.5,d:.5,h:1.2,c:'#5f7464'},
 {cat:'Wohnen',id:'plant',name:'Großpflanze',w:.8,d:.8,h:1.9,c:'#5f7464'},
 {cat:'Wohnen',id:'plant',name:'Kleine Pflanze',w:.3,d:.3,h:.5,c:'#5f7464',on:1},
 {cat:'Wohnen',id:'piano',name:'Klavier',w:1.5,d:.6,h:1.25,c:'#2c2d30'},
 {cat:'Wohnen',id:'aquarium',name:'Aquarium',w:1.2,d:.45,h:1.4,c:'#2c2d30'},
 {cat:'Wohnen',id:'stove',name:'Kaminofen',w:.55,d:.45,h:2.4,c:'#2c2d30'},
 {cat:'Wohnen',id:'curtain',name:'Vorhang',w:1.4,d:.08,h:2.45,c:'#e9e5dc'},
 {cat:'Wohnen',id:'picture',name:'Bild',w:.9,d:.03,h:.6,c:'#2c2d30',e:1.3},
 {cat:'Wohnen',id:'mirror',name:'Wandspiegel',w:.6,d:.03,h:.9,c:'#c9a272',e:1.2},
 {cat:'Essen',id:'table',name:'Esstisch',w:1.6,d:.9,h:.75,c:'#c9a272'},
 {cat:'Essen',id:'table',name:'Esstisch groß',w:2.2,d:1.0,h:.75,c:'#8a6648'},
 {cat:'Essen',id:'round',name:'Esstisch rund',w:1.1,d:1.1,h:.75,c:'#e9e5dc'},
 {cat:'Essen',id:'round',name:'Stehtisch',w:.7,d:.7,h:1.1,c:'#2c2d30'},
 {cat:'Essen',id:'chair',name:'Stuhl',w:.45,d:.52,h:.9,c:'#3f4a52'},
 {cat:'Essen',id:'bench',name:'Sitzbank',w:1.6,d:.38,h:.46,c:'#c9a272'},
 {cat:'Essen',id:'stool',name:'Barhocker',w:.4,d:.4,h:.78,c:'#2c2d30'},
 {cat:'Küche',id:'kitchen',name:'Küchenzeile',w:3.0,d:.62,h:2.2,c:'#e9e5dc'},
 {cat:'Küche',id:'kcorner',name:'Küche L-Form',w:3.0,d:2.2,h:2.2,c:'#e9e5dc'},
 {cat:'Küche',id:'island',name:'Kücheninsel',w:1.8,d:.9,h:.92,c:'#3f4a52'},
 {cat:'Küche',id:'kbase',name:'Unterschrank 60',w:.6,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'kbase',name:'Unterschrank 80',w:.8,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'kbase',name:'Unterschrank 40',w:.4,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'kdrawer',name:'Schubladenschrank 60',w:.6,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'ksink',name:'Spülenschrank 80',w:.8,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'khob',name:'Herd mit Kochfeld 60',w:.6,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'kdish',name:'Geschirrspüler 60',w:.6,d:.6,h:.9,c:'#e9e5dc'},
 {cat:'Küche',id:'kwall',name:'Hängeschrank 60',w:.6,d:.35,h:.7,c:'#e9e5dc',e:1.45},
 {cat:'Küche',id:'kwall',name:'Hängeschrank 80',w:.8,d:.35,h:.7,c:'#e9e5dc',e:1.45},
 {cat:'Küche',id:'ktall',name:'Hochschrank 60',w:.6,d:.6,h:2.1,c:'#e9e5dc'},
 {cat:'Küche',id:'koven',name:'Backofen-Hochschrank',w:.6,d:.6,h:2.1,c:'#e9e5dc'},
 {cat:'Küche',id:'fridge',name:'Kühlschrank',w:.6,d:.65,h:1.85,c:'#d9d4c9'},
 {cat:'Küche',id:'fridge2',name:'Side-by-Side Kühlschrank',w:.91,d:.72,h:1.78,c:'#c3c7ca'},
 {cat:'Küche',id:'hood',name:'Dunstabzugshaube',w:.6,d:.5,h:.9,c:'#c3c7ca',e:1.55},
 {cat:'Küche',id:'micro',name:'Mikrowelle',w:.5,d:.38,h:.3,c:'#2c2d30',on:1},
 {cat:'Küche',id:'coffeeM',name:'Kaffeevollautomat',w:.25,d:.42,h:.36,c:'#2c2d30',on:1},
 {cat:'Bad',id:'tub',name:'Badewanne',w:1.7,d:.75,h:.58,c:'#f5f5f2'},
 {cat:'Bad',id:'tub',name:'Badewanne 180',w:1.8,d:.8,h:.6,c:'#f5f5f2'},
 {cat:'Bad',id:'cornerTub',name:'Eckbadewanne',w:1.4,d:1.4,h:.58,c:'#f5f5f2'},
 {cat:'Bad',id:'shower',name:'Dusche',w:.9,d:.9,h:2.0,c:'#f5f5f2'},
 {cat:'Bad',id:'shower',name:'Dusche 120 × 90',w:1.2,d:.9,h:2.0,c:'#f5f5f2'},
 {cat:'Bad',id:'walkin',name:'Walk-in-Dusche',w:1.4,d:.9,h:2.0,c:'#f5f5f2'},
 {cat:'Bad',id:'wc',name:'WC',w:.38,d:.6,h:.8,c:'#f5f5f2'},
 {cat:'Bad',id:'wcwall',name:'Wand-WC mit Vorwand',w:.5,d:.55,h:1.15,c:'#f5f5f2'},
 {cat:'Bad',id:'bidet',name:'Bidet',w:.38,d:.55,h:.4,c:'#f5f5f2'},
 {cat:'Bad',id:'vanity',name:'Waschtisch',w:.8,d:.48,h:1.9,c:'#e9e5dc'},
 {cat:'Bad',id:'basin2',name:'Doppelwaschtisch',w:1.4,d:.5,h:1.9,c:'#c9a272'},
 {cat:'Bad',id:'mirrorcab',name:'Spiegelschrank',w:.8,d:.16,h:.7,c:'#e9e5dc',e:1.25},
 {cat:'Bad',id:'wardrobe',name:'Bad-Hochschrank',w:.4,d:.35,h:1.7,c:'#e9e5dc'},
 {cat:'Bad',id:'towelrad',name:'Handtuchheizkörper',w:.5,d:.04,h:1.2,c:'#f5f5f2',e:.2},
 {cat:'Bad',id:'basket',name:'Wäschekorb',w:.4,d:.4,h:.6,c:'#c9a272'},
 {cat:'Bad',id:'washer',name:'Waschmaschine',w:.6,d:.6,h:.85,c:'#f5f5f2'},
 {cat:'Bad',id:'washer',name:'Trockner',w:.6,d:.6,h:.85,c:'#f5f5f2'},
 {cat:'Bad',id:'washtower',name:'Wasch-Trocken-Säule',w:.6,d:.62,h:1.75,c:'#f5f5f2'},
 {cat:'Arbeiten',id:'desk',name:'Schreibtisch',w:1.4,d:.7,h:.75,c:'#e9e5dc'},
 {cat:'Arbeiten',id:'deskH',name:'Höhenverstellbarer Tisch',w:1.6,d:.8,h:.75,c:'#e9e5dc'},
 {cat:'Arbeiten',id:'office',name:'Bürostuhl',w:.6,d:.6,h:1.0,c:'#2c2d30'},
 {cat:'Arbeiten',id:'dresser',name:'Rollcontainer',w:.43,d:.58,h:.6,c:'#e9e5dc'},
 {cat:'Arbeiten',id:'sideboard',name:'Aktenschrank',w:1.0,d:.42,h:1.1,c:'#d9d4c9'},
 {cat:'Arbeiten',id:'shelf',name:'Aktenregal',w:.8,d:.4,h:1.9,c:'#d9d4c9'},
 {cat:'Arbeiten',id:'monitor',name:'Monitor',w:.62,d:.2,h:.5,c:'#2c2d30',on:1},
 {cat:'Arbeiten',id:'pc',name:'PC-Tower',w:.2,d:.45,h:.45,c:'#2c2d30'},
 {cat:'Arbeiten',id:'printer',name:'Drucker',w:.45,d:.4,h:.25,c:'#f5f5f2',on:1},
 {cat:'Licht',id:'ceilingLamp',name:'Deckenleuchte',w:.5,d:.5,h:.06,c:'#f5f5f2',e:2.3},
 {cat:'Licht',id:'pendant',name:'Pendelleuchte',w:.45,d:.45,h:.9,c:'#2c2d30',e:1.45},
 {cat:'Licht',id:'tablelamp',name:'Tischleuchte',w:.3,d:.3,h:.5,c:'#e9e5dc',on:1},
 {cat:'Flur',id:'coat',name:'Garderobe',w:1.0,d:.38,h:1.9,c:'#c9a272'},
 {cat:'Flur',id:'dresser',name:'Schuhschrank',w:1.0,d:.35,h:1.0,c:'#f5f5f2'},
 {cat:'Flur',id:'bench',name:'Garderobenbank',w:1.0,d:.38,h:.46,c:'#c9a272'},
 {cat:'Flur',id:'mirror',name:'Garderobenspiegel',w:.5,d:.03,h:1.4,c:'#2c2d30',e:.4},
 {cat:'Technik & Heizung',id:'radiator',name:'Heizkörper',w:1.0,d:.1,h:.6,c:'#f5f5f2',e:.12},
 {cat:'Technik & Heizung',id:'radiator',name:'Heizkörper hoch',w:.5,d:.1,h:1.8,c:'#f5f5f2',e:.1},
 {cat:'Technik & Heizung',id:'heatpump',name:'Wärmepumpe (außen)',w:1.1,d:.45,h:.85,c:'#d9d4c9'},
 {cat:'Technik & Heizung',id:'boiler',name:'Warmwasserspeicher',w:.65,d:.65,h:1.8,c:'#f5f5f2'},
 {cat:'Technik & Heizung',id:'boiler',name:'Pufferspeicher',w:.8,d:.8,h:1.9,c:'#c3c7ca'},
 {cat:'Technik & Heizung',id:'therme',name:'Heizgerät (Wand)',w:.45,d:.35,h:.75,c:'#f5f5f2',e:1.2},
 {cat:'Technik & Heizung',id:'tank',name:'Öltank 2000 l',w:1.5,d:.75,h:1.6,c:'#d9d4c9'},
 {cat:'Technik & Heizung',id:'tank',name:'Öltank 1000 l',w:1.1,d:.72,h:1.5,c:'#d9d4c9'},
 {cat:'Technik & Heizung',id:'fusebox',name:'Sicherungskasten',w:.55,d:.12,h:.8,c:'#f5f5f2',e:1.2},
 {cat:'Technik & Heizung',id:'wallbox',name:'Wallbox',w:.25,d:.12,h:.4,c:'#2c2d30',e:1.0},
 {cat:'Technik & Heizung',id:'ac',name:'Klimagerät (Wand)',w:.9,d:.22,h:.3,c:'#f5f5f2',e:2.05},
 {cat:'Technik & Heizung',id:'speaker',name:'Standlautsprecher',w:.25,d:.3,h:1.0,c:'#2c2d30'},
 {cat:'Technik & Heizung',id:'robot',name:'Saugroboter',w:.35,d:.35,h:.09,c:'#2c2d30'},
 {cat:'Keller & Hobby',id:'gfreezer',name:'Gefriertruhe',w:1.0,d:.65,h:.85,c:'#f5f5f2'},
 {cat:'Keller & Hobby',id:'fridge',name:'Getränkekühlschrank',w:.55,d:.6,h:.85,c:'#2c2d30'},
 {cat:'Keller & Hobby',id:'heavyShelf',name:'Schwerlastregal',w:1.2,d:.5,h:1.8,c:'#3f4a52'},
 {cat:'Keller & Hobby',id:'workbench',name:'Werkbank',w:1.5,d:.7,h:.9,c:'#3f4a52'},
 {cat:'Keller & Hobby',id:'treadmill',name:'Laufband',w:.85,d:1.9,h:1.4,c:'#2c2d30'},
 {cat:'Keller & Hobby',id:'sauna',name:'Sauna',w:2.0,d:1.6,h:2.05,c:'#c9a272'},
 {cat:'Garten & Terrasse',id:'table',name:'Gartentisch',w:1.8,d:.9,h:.75,c:'#8a6648'},
 {cat:'Garten & Terrasse',id:'chair',name:'Gartenstuhl',w:.5,d:.55,h:.9,c:'#2c2d30'},
 {cat:'Garten & Terrasse',id:'corner',name:'Gartenlounge',w:2.6,d:2.0,h:.75,c:'#8c8f91'},
 {cat:'Garten & Terrasse',id:'lounger',name:'Sonnenliege',w:.7,d:1.95,h:.45,c:'#d9d4c9'},
 {cat:'Garten & Terrasse',id:'parasol',name:'Sonnenschirm',w:3.0,d:3.0,h:2.5,c:'#e9e5dc'},
 {cat:'Garten & Terrasse',id:'grill',name:'Gasgrill',w:1.3,d:.6,h:1.15,c:'#2c2d30'},
 {cat:'Garten & Terrasse',id:'firepit',name:'Feuerschale',w:.8,d:.8,h:.5,c:'#2c2d30'},
 {cat:'Garten & Terrasse',id:'raised',name:'Hochbeet',w:2.0,d:.8,h:.8,c:'#8a6648'},
 {cat:'Garten & Terrasse',id:'plant',name:'Kübelpflanze',w:.6,d:.6,h:1.4,c:'#5f7464'},
 {cat:'Garten & Terrasse',id:'bush',name:'Strauch',w:1.2,d:1.2,h:1.3,c:'#5f7464'},
 {cat:'Garten & Terrasse',id:'hedge',name:'Hecke',w:3.0,d:.6,h:1.6,c:'#4f7a3a'},
 {cat:'Garten & Terrasse',id:'tree',name:'Baum',w:3.0,d:3.0,h:5.0,c:'#5f8a43'},
 {cat:'Garten & Terrasse',id:'pool',name:'Pool rund',w:3.6,d:3.6,h:1.2,c:'#9db4c9'},
 {cat:'Garten & Terrasse',id:'trampoline',name:'Trampolin',w:3.0,d:3.0,h:.9,c:'#2c2d30'},
 {cat:'Garten & Terrasse',id:'shed',name:'Gerätehaus',w:2.4,d:2.0,h:2.2,c:'#8a6648'},
 {cat:'Garten & Terrasse',id:'heatpump',name:'Wärmepumpe',w:1.1,d:.45,h:.85,c:'#d9d4c9'},
 {cat:'Garage',id:'car',name:'Auto',w:1.8,d:4.5,h:1.5,c:'#9db4c9'},
 {cat:'Garage',id:'car',name:'Kleinwagen',w:1.7,d:3.9,h:1.45,c:'#a3664a'},
 {cat:'Garage',id:'car',name:'SUV',w:1.9,d:4.7,h:1.7,c:'#2c2d30'},
 {cat:'Garage',id:'bike',name:'Fahrrad',w:.6,d:1.75,h:1.05,c:'#3f6d8c'},
 {cat:'Garage',id:'bike',name:'Kinderfahrrad',w:.5,d:1.3,h:.8,c:'#c8a6a0'},
 {cat:'Garage',id:'mower',name:'Rasenmäher',w:.55,d:1.4,h:1.0,c:'#5f7464'},
 {cat:'Garage',id:'heavyShelf',name:'Garagenregal',w:1.8,d:.5,h:2.0,c:'#3f4a52'},
 {cat:'Garage',id:'bin',name:'Mülltonne Rest',w:.58,d:.73,h:1.07,c:'#2c2d30'},
 {cat:'Garage',id:'bin',name:'Mülltonne Bio',w:.58,d:.73,h:1.07,c:'#5b4636'},
 {cat:'Garage',id:'bin',name:'Mülltonne Papier',w:.58,d:.73,h:1.07,c:'#3f6d8c'},
 {cat:'Garage',id:'bin',name:'Gelbe Tonne',w:.58,d:.73,h:1.07,c:'#d8b62f'},
];
export const CATALOG: CatalogDef[] = ENTRIES.map((c) => ({ ...c, key: c.key || c.id + "_" + c.name }));
export const GARAGE_IDS: Record<string, 1> = { car: 1, bike: 1, mower: 1, bin: 1 };
const ROUND_IDS: Record<string, 1> = { round: 1, pool: 1, trampoline: 1 };
export const isRound = (id: string) => !!ROUND_IDS[id];

/** Katalogeintrag zu einem gespeicherten Schlüssel; eigene Möbel beginnen mit "cu:". */
export function defOf(k: string, custom: CustomDef[]): CatalogDef {
  if (k && k.startsWith("cu:")) {
    const c = custom.find((c) => c.key === k);
    if (c) return { ...c, cat: "Eigene Möbel", id: "custom" };
    return { key: k, cat: "Eigene Möbel", id: "custom", name: "Eigenes Möbel (gelöscht)", w: 0.6, d: 0.6, h: 0.6, c: "#cccccc", parts: [] };
  }
  return CATALOG.find((c) => c.key === k) || CATALOG[0];
}
